<template>
    <div class="bomComparison" ref="jo">
        <div style="height: 6px"></div>
        <div style="padding: 6px">
            <span style="font-size: 16px; padding-left: 14px">
                <i class="icon">
                    <img style="width: 100%; height: 100%" src="@/assets/tag.png" alt="" />
                </i>
                {{$t("message.title.BOMCompare")}}
            </span>
        </div>

        <div style="padding: 0 20px">
            <!-- 表格区域 -->
            <vxe-grid
                v-bind="gridOptions"
                resizable
                ref="table"
                :print-config="{}"
                :tree-config="{ transform: true, expandAll: true }"
                :toolbar-config="tableToolbar">
                <template #tools>
                    <el-button
                        @click="searchAddBom = true"
                        size="small"
                        type="primary"
                        >{{$t("message.button.add")}}
                    </el-button>
                    <el-button
                        @click="bomComparison"
                        size="small"
                        type="primary"
                        >{{$t("message.title.BOMCompare")}}
                    </el-button>
                </template>
            </vxe-grid>
        </div>
        <el-dialog v-if="searchAddBom" 
            width='65%' class="searchAddBomList" 
            :title="$t('message.title.add')" 
            :visible.sync="searchAddBom" 
            :close-on-click-modal="!searchAddBom" 
            :close-on-press-escape="false">
            <!-- <searchAdd @listDbClick="addList" :creatBy = 'creatBy' :departmentList = 'departmentList'> -->
            <searchAdd @listDbClick="addList"></searchAdd>
        </el-dialog>
    </div>

</template>

<style scoped>
    .icon {
        display: inline-block;
        width: 18px;
        height: 18px;
        position: relative;
        top: 3px;
    }
</style>

<script>
import axios from "axios";
import searchAdd from "@/components/searchAdd.vue";
export default {
    name:'BOMCompare',
    data() {
        return {
            oldTableData:[],
            advancedSearch:true,
            creatNew:"",
            searchAddBom: false, //添加窗口开关
            tableToolbar: {
                // custom: true,
                buttons: [{ code: 'myInsert', name: '' ,type: 'text',},],
                slots: {
                    tools: "tools",
                },
            },
            creatBy:'BOM',
            gridOptions: {
                border: true,
                resizable: true,
                showOverflow: true,
                // stripe: true,
                height: 660,
                align: "left",
                highlightHoverRow: true,
                treeConfig: { children: "children", expandAll: true },
                columns: [],
                data: [],
            },
        }
    },
    methods: {
        bomComparison(){
            let checkRow = this.$refs.table.getCheckboxRecords();
            //console.log(checkRow.length);
            let obj = {};
            if(checkRow.length == 1){
                obj.id = checkRow[0].id;
                obj.subClassId = checkRow[0].subClassId;
            } else if(checkRow.length == 2){
                obj.id = checkRow[0].id;
                obj.subClassId = checkRow[0].subClassId;

                obj.id2 = checkRow[1].id;
                obj.subClassId2 = checkRow[1].subClassId;
            } else if(checkRow.length > 2){
                this.$message.error(this.$t('message.error.onlyOneOrTwo'));
                return false
            };
            let routeUrl = this.$router.resolve({
                path: "/BomComparison",
                query: obj
            });
            window.open(routeUrl.href, '_blank');
        },
        addList(row) {
            console.log(row);
            let object1 = this.deepClone(this.oldTableData);
            console.log(object1);
            let newRow = [];
            if(row[0].isAdvancedSearch){
                row.map(item => {
                    let obj = {};
                    obj[0] = item[1000001]?item[1000001]:"";
                    obj[1] = item[1000003]?item[1000003]:"";
                    obj[2] = item[1000002]?item[1000002]:"";
                    obj[3] = item[1000006]?item[1000006]:"";
                    obj.children = item.children;
                    obj.id = item.id;
                    obj.itemNumber = item.itemNumber;
                    obj.parentId = item.parentId;
                    obj.subClassId = item.ObjectId.subClassId;
                    newRow.push(obj);
                });
                // newRow[0] = row[1000001]?row[1000001]:"";
                // newRow[1] = row[1000003]?row[1000003]:"";
                // newRow[2] = row[1000002]?row[1000002]:"";
                // newRow[3] = row[1000006]?row[1000006]:"";
            } else {
                newRow = row;
            };
            console.log(newRow);
            if(object1.length == 0){
                this.gridOptions.data = newRow;
                this.oldTableData = this.deepClone(newRow);
            } else {
                newRow.map(item => {
                    object1.push(item)
                });
                this.gridOptions.data = this.deteleObject(object1);
            };
            this.searchAddBom = false;
            //添加
            // if (row) {
            //     // this.searchAddBom = false;
            //     var change_info = this.$store.state.change_info;
            //     let insertBom = [];
            //     let systemName = window.sessionStorage.getItem("systemName");
            //     row.map((i) => {
            //     let obj = {
            //         childId: i.id,
            //         '1003001': i.itemNumber,
            //         '1003003': i.quantity,
            //         itemId: this.$store.state.objId_,
            //     };
            //     if(systemName.indexOf('奥斯汀') != -1){
            //         Object.assign(obj,{'1003078':i.department.join(';')})
            //     } 
            //     insertBom.push(obj)
            //     })
            //     var updateBomData = {
            //     //post更改的值
            //     tableId: 4,
            //     changeObjId: {
            //         id: change_info.changeId,
            //         classId: change_info.changeClassId,
            //         subClassId: change_info.changeSubClassId,
            //     },
            //     itemObjId: {
            //         ... this.$store.state.objectId,
//id: this.$store.state.objId_,
            //         //classId: this.$store.state.classId_,
            //         //subClassId: this.$store.state.subClassId_,
            //         version: this.version,
            //     },
            //     insertBom: insertBom,
            //     };
            //     var vm = this;
            //     axios
            //     .post("/pmdm/items/saveTable", updateBomData)
            //     .then(function (res) {
            //         if (res.data.code == 200) {
            //         vm.$message({
            //             message: res.data.message,
            //             type: "success",
            //         });
            //         vm.getBomInfo();
            //         // vm.$refs.xGrid.revertData();
            //         }
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
            // }
        },
        addM() {
            this.creatNew = true;
        },
        loadColumns(){
            let vm = this;
            var obj_get = {
                //获取url参数
                baseClassId: 101,
                value: "",
                size: 1,
                page: 1,
            };
            axios.get(`/pmdm/search/simple${this.params(obj_get)}`).then(res => {
                console.log(res);
                if (res.data.code == 200) {
                    vm.gridOptions.columns = vm.getNewTableTitleData(res.data);
                }
            })
        }

    },
    mounted(){
        
    },
    components: {
        searchAdd,
    },
    created() {
        this.loadColumns();
        this.$store.commit('setIncludesList','BOMCompare');
    }
}
</script>
